import type { ModulatorLinkCsId } from "~domain/devices/models/links/link-model.ts";
import type { ModulatorCsId } from "~domain/devices/models/modulators/modulator-model.ts";

import { z } from "zod";

export const backofficeFindSiteModulatorsWorkingConditionResponseSchema = z.array(
  z.object({
    acqRate: z.object({
      interpreted: z.number(),
      isECS: z.boolean(),
      raw: z.number(),
    }),
    csModulatorId: z.number().transform((s) => s as ModulatorCsId),
    csLinkId: z.number().transform((s) => s as ModulatorLinkCsId),
    lastConnectionDate: z.coerce.date().nullable(),
    lastPointDate: z.coerce.date().nullable(),
    modulationEndDate: z.coerce.date().nullable(),
    linkModulationPerformance: z
      .object({
        modulationNumber: z.number().nullable(),
        modulationPerformancePercentage: z.number().nullable(),
      })
      .nullable(),
  }),
);

export type BackofficeFindSiteModulatorsWorkingConditionResponse = z.infer<
  typeof backofficeFindSiteModulatorsWorkingConditionResponseSchema
>;
